import { Memory } from '@ow/lowdb'
import LowDittoDB from './low-ditto-db'

export default function createLowDB(opts) {
  return new LowDittoDB(new Memory(), opts)
}
